export default __webpack_public_path__ + "static/media/money.7506a15b.png";